import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Lucas',
  text: 'Dejé de empezar mil veces y por fin pude ser constante.'
}, {
  name: 'Sofía',
  text: 'Me ayudó a salir del estancamiento en el que estaba hace meses.'
}, {
  name: 'Martín',
  text: 'Lo que más me sirvió es que es simple. No te abruma.'
}, {
  name: 'Valentina',
  text: 'En pocos días ya me sentía con más energía y enfoque.'
}, {
  name: 'Agustín',
  text: 'Por primera vez siento que tengo control sobre mi rutina.'
}];
export function Testimonials() {
  return <section className="py-20 md:py-28 px-4 bg-cream" data-id="element-200">
      <div className="max-w-6xl mx-auto" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-202">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4 font-serif" data-id="element-203">
            Lo que dicen quienes ya empezaron
          </h2>
          <div className="flex justify-center gap-1 text-highlight" data-id="element-204">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-205" />)}
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-206">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-border flex flex-col h-full" data-id="element-207">
              <div className="flex gap-1 text-highlight mb-4" data-id="element-208">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-209" />)}
              </div>
              <p className="text-secondary text-lg italic mb-6 flex-grow" data-id="element-210">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-211">
                <div className="w-10 h-10 rounded-full bg-beige flex items-center justify-center text-nude-dark font-bold font-serif" data-id="element-212">
                  {t.name.charAt(0)}
                </div>
                <p className="font-bold text-primary" data-id="element-213">{t.name}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}